import { Controller } from "@hotwired/stimulus"

// Select-all checkbox + hidden field population for mass update forms.
export default class extends Controller {
  static targets = ["selectAll", "checkbox", "itemIds"]

  selectAllChanged() {
    const checked = this.selectAllTarget.checked
    this.checkboxTargets.forEach(cb => cb.checked = checked)
    this.fillItemIds()
  }

  checkboxChanged() {
    this.fillItemIds()
  }

  fillItemIds() {
    if (!this.hasItemIdsTarget) return
    const ids = this.checkboxTargets
      .filter(cb => cb.checked)
      .map(cb => cb.value)
      .join(',')
    this.itemIdsTarget.value = ids
  }

  warnIfEmpty() {
    if (this.checkboxTargets.filter(cb => cb.checked).length === 0) {
      alert('Warning, nothing is selected above.')
    }
  }
}
